import React, { useEffect, useRef } from "react";
import { ProfileImages } from "./images";

// Custom Sort Icon Component
const SortIcon = ({ isSorted, isSortedDesc, filterIcon }) => {
  if (!isSorted) {
    // Default unsorted state - using your custom filterIcon
    return (
      <img
        src={filterIcon}
        alt="filter"
        className="h-3 w-2 mt-1 cursor-pointer opacity-60"
      />
    );
  }

  if (isSortedDesc) {
    // Descending - down arrow
    return (
      <svg
        className="h-3 w-3 mt-1 text-blue-600"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M5 8l5 5 5-5H5z" />
      </svg>
    );
  }

  // Ascending - up arrow
  return (
    <svg
      className="h-3 w-3 mt-1 text-blue-600"
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path d="M15 12l-5-5-5 5h10z" />
    </svg>
  );
};

const ReusableTable = ({
  getTableProps,
  getTableBodyProps,
  headerGroups,
  tablePage,
  prepareRow,
  page,
  searchTerm,
  drop,
  filterIcon = ProfileImages.filter,
  errorMsg
}) => {
  return (
    <div className="flex flex-col justify-between">
      <div className="min-h-[75vh]">
        <table {...getTableProps()} className="w-full table-fixed">
          <thead
            className={`${drop ? "" : "sticky top-0"} bg-white z-10 shadow-md`}
          >
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={column.id}
                    className="bg-gray-100 text-[#8177A8] text-left text-[12px] p-2 flex-grow"
                  >
                    <div className="flex flex-row">
                      <div
                        className={`flex flex-row justify-center gap-1 text-center whitespace-nowrap ${column.Header === "Role" ? "ml-24" : ""
                          } 
                          ${column.Header === "S.No" ? "ml-2" : ""}
                           ${column.Header === "Registered On" ? "pl-8" : ""}
                            ${column.Header === "Completion" ? "pl-8" : ""}
                          ${column.Header === "Name" ? "ml-2" : ""} 
                          ${column.Header !== "Role" &&
                            column.Header !== "Name" &&
                            column.Header !== "S.No"
                            ? "ml-14"
                            : ""
                          } ${column.Header === "Contact" ? "pl-6" : ""} ${column.Header === "Profile" ? "ml-8" : ""
                          } ${column.Header === "Locations" ? "pl-8" : ""}${column.Header === "Aadhaar" ? "pl-4" : ""
                          } ${column.Header === "Payment" ? "pl-8" : ""} `}
                      >
                        {column.render("Header")}
                        {!column.disableSortBy && column.canSort && (
                          <SortIcon
                            isSorted={column.isSorted}
                            isSortedDesc={column.isSortedDesc}
                            filterIcon={filterIcon}
                          />
                        )}
                        {!column.disableSortBy && !column.canSort && (
                          <img
                            src={filterIcon}
                            alt="filter"
                            className="h-3 w-2 mt-1 cursor-pointer opacity-60"
                          />
                        )}
                      </div>
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          {tablePage.length === 0 ? (
            <tbody>
              <tr>
                <td
                  colSpan={headerGroups[0]?.headers.length || 1}
                  className="text-center p-28 text-gray-500 font-poppins text-[14px]"
                >
                  {errorMsg ? errorMsg : "No users found"}
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody {...getTableBodyProps()} className="bg-white flex-grow">
              {tablePage.map((row) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    key={row.id}
                    className="hover:bg-[#dceffc]"
                  >
                    {row.cells.map((cell) => (
                      <td
                        {...cell.getCellProps()}
                        key={cell.column.id}
                        className={`p-1.5 text-[12px] border-b border-[#D7E4EB] ${cell.column.Header === "Role" ? "pl-24" : ""
                          }
                        ${cell.column.Header === "S.No" ? "pl-6" : ""}
                        ${cell.column.Header === "Name" ? "pr-10" : ""} 
                        ${cell.column.Header !== "Role" &&
                            cell.column.Header !== "Name" &&
                            cell.column.Header !== "S.No"
                            ? "pl-16"
                            : ""
                          }
                        ${cell.column.Header === "Name" ? "pr-10" : ""}
                        ${cell.column.Header === "Locations" ? "pr-2" : ""} ${cell.column.Header === "Payment" ? "" : ""
                          }
                           ${cell.column.Header === "Registered On" ? "" : ""}${cell.column.Header === "Aadhaar" ? "" : ""
                          }`}
                      >
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
};

export default ReusableTable;
